module.exports = __webpack_public_path__ + "img/refund-poin.28503579.png";